import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Loader } from "@/components/common";

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined);
  useEffect(() => {
    setPage(undefined);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setPage(null));
  }, [slug]);

  if (page === undefined) return <Loader />;
  if (page === null) {
    return (
      <div className="max-w-3xl mx-auto py-16 text-center" data-testid="page-not-found">
        <h1 className="font-display text-2xl font-bold text-[#0F172A]">Page introuvable</h1>
        <p className="text-slate-500 mt-2">Cette page n'existe pas ou a été désactivée.</p>
        <Link to="/" className="inline-block mt-4 text-[#C85A32] font-semibold">Retour à l'accueil</Link>
      </div>
    );
  }
  return (
    <article className="max-w-3xl mx-auto py-6" data-testid="dynamic-page">
      <h1 className="font-display text-3xl font-extrabold text-[#0F172A] mb-4" data-testid="page-title">{page.title}</h1>
      {page.image && <img src={page.image} alt={page.title} className="w-full rounded-xl mb-6 object-cover max-h-72" />}
      <div className="prose prose-slate max-w-none text-slate-700" data-testid="page-content" dangerouslySetInnerHTML={{ __html: page.content || "<p>Contenu à venir.</p>" }} />
    </article>
  );
}
